import { useCallback } from 'react';
import { useApi } from '@core/http/useApi';
import { useAppDispatch } from '@core/store/store';
import { AccessProfile } from '@models/AccessProfile';
import { apiPaths } from '@core/http/apiPaths';
import { accountsReducer } from '@core/store/library-stores/accounts';
import { getPathPayload } from '@hwm/ui-lib';

export const useUserDetailsDataSource = () => {
  const dispatch = useAppDispatch();

  const [getUserAccessProfile, userAccessProfile, loading, error] = useApi<
    AccessProfile,
    null,
    getPathPayload<typeof apiPaths.users.getAccessProfile>
  >(
    useCallback((params) => apiPaths.users.getAccessProfile(params), []),
    'get'
  );

  const handleGetUserAccessProfile = useCallback(
    (userId: number) => {
      if (userId) {
        getUserAccessProfile({ id: userId }).catch(() => dispatch(accountsReducer.slice.actions.setUserRole(null)));
      }
    },
    [dispatch, getUserAccessProfile]
  );

  return {
    userAccessProfile,
    getUserAccessProfile: handleGetUserAccessProfile,
    loading,
    error,
  };
};
